import styled from 'styled-components';
import { ReactComponent as RawExportSVG } from '../../../../assets/icons/icon_export.svg';

export const IconExport = styled(RawExportSVG)``;
